const sessionObjectUrls = new Set<string>();

export function registerPhotoSessionUrls(objectUrls: string[]) {
  objectUrls.forEach((objectUrl) => sessionObjectUrls.add(objectUrl));
}

export function hasPhotoSessionUrl(objectUrl: string) {
  return sessionObjectUrls.has(objectUrl);
}
